import React from 'react';
import './FeatureUnavailable.scss';
import { Link as RouterLink } from 'react-router-dom';
import { Icon, Link } from '@saviynt/design-system';

function FeatureUnavailable({ errorDetails, linkText, linkUrl }) {
  return (
    <div className="FeatureUnavailable">
      <div className="FeatureUnavailable-Icon-Holder">
        <Icon
          kind="AlertCriticalFilledSeparateColors"
          className="FeatureUnavailable-Icon"
          color="--color-foreground-critical-medium"
        />
      </div>
      <div>
        <span className="FeatureUnavailable-Title">Feature Unavailable. </span>
        <span className="FeatureUnavailable-Description">
          {errorDetails}
          <Link
            className="FeatureUnavailable-Link"
            RouterComponent={RouterLink}
            url={linkUrl}
            text={linkText}
            size="medium"
            suffixIconKind="ChevronRight"
          />
        </span>
      </div>
    </div>
  );
}

export default FeatureUnavailable;
